import React from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  makeStyles,
} from '@material-ui/core'
import PropTypes from 'prop-types'
import moment from 'moment'
import ColoredCell from './ColoredCell'
import { ksTheme } from '../../../theme'
import formatCurrency from '../../../utils/formatCurrency'
import getDiscountValue from '../../../utils/getDiscountValue'

const useStyles = makeStyles({
  headerCell: {
    fontSize: '1.2rem',
    fontWeight: 'bold',
  },
})

const getPacingColor = pacingValue => {
  if (!pacingValue) return 'transparent'

  const pacing = parseFloat(pacingValue.replace('%', ''))

  if (pacing <= 100) {
    return ksTheme.colors.kellyGreen.light
  }

  return ksTheme.colors.red
}

const WipReportTable = ({ wipData, project }) => {
  const classes = useStyles()
  const tableData = {
    staffHours: {
      label: 'Staff Hours (Hrs)',
      submitted: wipData.submittedHours.staffHours,
    },
    /* expertHours: {
      label: 'Expert Hours (Hrs)',
      submitted: wipData.submittedHours.expertHours,
    }, */
    staffExpenses: {
      label: 'Staff Expenses (Cost & Disbursements)',
      submitted: formatCurrency(wipData.submittedExpenses.staffExpenses, project.CurrencyIsoCode),
    },
    /* expertExpenses: {
      label: 'Expert Expenses (Cost & Disbursements)',
      submitted: formatCurrency(wipData.submittedExpenses.expertExpenses, project.CurrencyIsoCode),
    }, */
    totalFeeeAndExpenses: {
      label: 'Total Fees + Total Expenses',
      submitted: formatCurrency(
        wipData.submittedHours.staffRate + wipData.submittedExpenses.staffExpenses,
        project.CurrencyIsoCode,
      ),
    },
    /* writeOffs: {
      label: 'Write Offs',
      submitted: formatCurrency(wipData.submittedWriteOffs, project.CurrencyIsoCode),
    },
    Discounts: {
      label: 'Discounts',
      submitted: formatCurrency(getDiscountValue(wipData.invoiceDiscount, wipData.submittedHours.staffRate), project.CurrencyIsoCode),
    },
    invoiceTotal: {
      label: 'Invoice Total',
      submitted: formatCurrency(wipData.totalFeesAndExpenses - getDiscountValue(wipData.invoiceDiscount, wipData.submittedHours.staffRate), project.CurrencyIsoCode),
    }, */
  }

  return (
    <TableContainer
      component={Paper}
      style={{ width: '50%', margin: 'auto', marginTop: '40px' }}
      data-testid="wip.reportTable"
    >
      <Table aria-label="WIP Report Table">
        <TableHead>
          <TableRow>
            <TableCell className={classes.headerCell}>Current Staff Summary</TableCell>
            <TableCell className={classes.headerCell}>Submitted</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Object.values(tableData).map((row, index) => (
            <TableRow key={index}>
              <TableCell>{row.label}</TableCell>
              <TableCell>{row.submitted}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

WipReportTable.propTypes = {
  wipData: PropTypes.object.isRequired,
}

export default WipReportTable
